import FreeProducts from '@/components/FreeProducts'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		vouchers: [],
		...opts,
		vueComponent: FreeProducts
	}

	let page = vuewidget(dom, options)
	return page
}